const destinationsData = [
  {
    slug: 'cancun-tulum-riviera-maya',
    title: 'Cancun, Tulum & Riviera Maya',
    title_es: 'Cancún, Tulum & Riviera Maya',
    desc: "Tropical paradise, pristine beaches, luxury resorts.",
    desc_es: "Paraíso tropical, playas prístinas, resorts de lujo.",
    image: '/images/cancun3.jpg',
    heroImage: '/images/cancun.jpg',
    magicImage: '/images/ctr_2.jpg',
    experienceImage: '/images/ctr_3.jpg',
    footerSliverImage: '/images/cancun_3.jpg',
    sectionImage: '/images/beach_seating.jpg',
    overview: "The Riviera Maya is a stunning stretch of Caribbean coastline featuring pristine beaches, ancient Mayan ruins, and world-class luxury resorts, encompassing Cancun, Tulum, and the surrounding areas. From Cancun's vibrant energy to Tulum's bohemian charm, this region offers diverse experiences for every couple.",
    overview_es: "La Riviera Maya es un impresionante tramo de costa caribeña con playas prístinas, antiguas ruinas mayas y resorts de lujo de clase mundial, que abarca Cancún, Tulum y las áreas circundantes. Desde la vibrante energía de Cancún hasta el encanto bohemio de Tulum, esta región ofrece experiencias diversas para cada pareja.",
    weddingsDesc: "Weddings here combine Caribbean beauty with Mayan mystique, offering everything from beach ceremonies to jungle celebrations. Choose between Cancun's luxury resorts, Tulum's eco-chic venues, or secluded Riviera Maya hideaways.",
    weddingsDesc_es: "Las bodas aquí combinan la belleza caribeña con la mística maya, ofreciendo desde ceremonias en la playa hasta celebraciones en la jungla. Elige entre los resorts de lujo de Cancún, los lugares eco-chic de Tulum o los refugios aislados de la Riviera Maya.",
    bestTime: 'November to April',
    bestTime_es: 'Noviembre a Abril',
    nearestAirport: 'Cancun International Airport (CUN)',
    nearestAirport_es: 'Aeropuerto Internacional de Cancún (CUN)',
    airportInternational: 'Cancun International Airport (CUN)',
    airportInternational_es: 'Aeropuerto Internacional de Cancún (CUN)',
    airportDomestic: 'Cancun International Airport (CUN)',
    airportDomestic_es: 'Aeropuerto Internacional de Cancún (CUN)',
    airportPrivate: 'Cancun International Airport (CUN)',
    airportPrivate_es: 'Aeropuerto Internacional de Cancún (CUN)',
    featuredVenues: [
      { name: 'Nizuc Resort & Spa', image: '/images/nizuc.jpg' },
      { name: 'Le Blanc Spa Resort', image: '/images/le-blanc.jpg' },
      { name: 'Secrets The Vine', image: '/images/secrets-vine.jpg' },
      { name: 'Rosewood Mayakoba', image: '/images/rosewood.jpg' },
      { name: 'Grand Velas Riviera Maya', image: '/images/velas.jpg' },
      { name: 'Banyan Tree Mayakoba', image: '/images/banyan.jpg' }
    ],
    localTouch: "Experience beachfront ceremonies, enjoy water activities, and celebrate in luxury resorts with ocean views.",
    localTouch_es: "Vive ceremonias frente al mar, disfruta actividades acuáticas y celebra en resorts de lujo con vistas al océano.",
    topActivities: [
      'Beach ceremony',
      'Snorkeling',
      'Spa treatments',
      'Water sports',
      'Island tour',
      'Sunset cruise',
      'Mayan ruins exploration',
      'Cenote swimming'
    ],
    topActivities_es: [
      'Ceremonia en la playa',
      'Snorkel',
      'Tratamientos de spa',
      'Deportes acuáticos',
      'Tour de islas',
      'Crucero al atardecer',
      'Exploración de ruinas mayas',
      'Nado en cenotes'
    ],
    magicExperience: `The Riviera Maya is where the Caribbean's turquoise waters meet pristine white sand beaches. From the moment you arrive, you're transported to a world of tropical luxury and natural beauty. Picture beachfront ceremonies with the gentle sound of waves, sunset celebrations on private terraces, and moonlit receptions under the stars. Here, every detail is crafted to create an unforgettable celebration in paradise.`,
    magicExperience_es: `La Riviera Maya es donde las aguas turquesas del Caribe se encuentran con playas de arena blanca prístina. Desde el momento en que llegas, te transportas a un mundo de lujo tropical y belleza natural. Visualiza ceremonias frente al mar con el suave sonido de las olas, celebraciones al atardecer en terrazas privadas y recepciones bajo la luz de la luna y las estrellas. Aquí, cada detalle está elaborado para crear una celebración inolvidable en el paraíso.`,
    vibe: `The Riviera Maya radiates an atmosphere of tropical luxury and relaxed sophistication. Days begin with yoga on the beach, followed by water activities and poolside relaxation. As the sun sets, the energy shifts to elegant beachfront dinners, live music under the stars, and dancing beneath swaying palm trees. Every moment here feels like a celebration of paradise, every experience enhanced by the natural beauty of the Caribbean.`,
    vibe_es: `La Riviera Maya irradia una atmósfera de lujo tropical y sofisticación relajada. Los días comienzan con yoga en la playa, seguidas de actividades acuáticas y relajación junto a la piscina. Al caer el sol, la energía se transforma en elegantes cenas frente al mar, música en vivo bajo las estrellas y baile bajo palmeras que se mecen. Cada momento aquí se siente como una celebración del paraíso, cada experiencia mejorada por la belleza natural del Caribe.`,
    climateSeasons: `From November to April, the Riviera Maya enjoys perfect weather with warm temperatures, gentle breezes, and minimal rainfall—ideal for beach weddings and outdoor celebrations. The summer months bring warmer temperatures and occasional tropical showers, creating lush landscapes and vibrant sunsets.`,
    climateSeasons_es: `De noviembre a abril, la Riviera Maya disfruta de un clima perfecto con temperaturas cálidas, brisas suaves y lluvias mínimas—ideal para bodas en la playa y celebraciones al aire libre. Los meses de verano traen temperaturas más cálidas y lluvias tropicales ocasionales, creando paisajes exuberantes y atardeceres vibrantes.`,
    accessibilityDetails: `The Riviera Maya is easily accessible through Cancun International Airport (CUN), which offers numerous direct flights from major cities worldwide. Upon arrival, most resorts are just a short transfer away, with many offering private transportation services. The region's well-maintained highway system makes it easy to explore different areas, from the vibrant energy of Cancun to the bohemian charm of Tulum.`,
    accessibilityDetails_es: `La Riviera Maya es fácilmente accesible a través del Aeropuerto Internacional de Cancún (CUN), que ofrece numerosos vuelos directos desde las principales ciudades del mundo. Al llegar, la mayoría de los resorts están a solo un corto traslado, con muchos ofreciendo servicios de transporte privado. El sistema de carreteras bien mantenido de la región facilita la exploración de diferentes áreas, desde la vibrante energía de Cancún hasta el encanto bohemio de Tulum.`,
    experienceBlurb: 'From exploring ancient Mayan ruins to swimming in crystal-clear cenotes,',
    experienceBlurb_es: 'De explorar antiguas ruinas mayas a nadar en cenotes cristalinos,',
    weddingVenues: [
      "nizuc-resort",
      "azulik-tulum",
      "chable-maroma",
      "rosewood-mayakoba",
      "grand-velas-riviera-maya",
      "banyan-tree-mayakoba"
    ],
    bestWeddingVenues: [
      "nizuc-resort",
      "le-blanc-cancun",
      "secrets-vine",
      "rosewood-mayakoba",
      "grand-velas-riviera-maya",
      "banyan-tree-mayakoba"
    ],
    hotelsResortsStays: [
      {
        id: "nizuc-resort-spa",
        name: "Nizuc Resort & Spa",
        name_es: "Nizuc Resort & Spa",
        description: "An architectural icon in Punta Nizuc, blending contemporary style with Mayan heritage. Private villas, gourmet dining, serene beaches, and a renowned ESPA spa.",
        description_es: "Ícono arquitectónico en Punta Nizuc, fusiona estilo contemporáneo y herencia maya. Villas privadas, gastronomía gourmet, playas serenas y un spa ESPA de renombre.",
        imageUrl: "/images/ctr_nizuk.jpg",
        location: "Blvd. Kukulcán Km. 21.26, Punta Nizuc, Cancún, Quintana Roo",
        rating: "4.9/5.0"
      },

      {
        id: "rosewood-mayakoba",
        name: "Rosewood Mayakoba",
        name_es: "Rosewood Mayakoba",
        description: "An award-winning, ultra-exclusive resort blending nature, architecture, and luxury. Private suites and villas set along lagoons and the Caribbean, with butler service and world-class spa.",
        description_es: "Un resort galardonado y ultra exclusivo que fusiona naturaleza, arquitectura y lujo. Suites y villas privadas en lagunas y mar Caribe, con servicio de mayordomo y spa de clase mundial.",
        imageUrl: "/images/ctr_rosewood_mayacoba_hotel.jpg",
        location: "Carretera Federal 307, Km 298, Mayakoba, Playa del Carmen, Quintana Roo",
        rating: "5.0/5.0"
      },
      {

          id: "banyan-tree-mayakoba",
          name: "Banyan Tree Mayakoba",
          name_es: "Banyan Tree Mayakoba",
          description: "An award-winning luxury resort in Playa del Carmen, seamlessly blending Asian hospitality with Mexican culture. Set amidst lush mangroves and tranquil waterways, each of its 162 villas features a private heated pool, offering guests unparalleled privacy and comfort.",
          description_es: "Un resort de lujo galardonado en Playa del Carmen, que combina la hospitalidad asiática con la cultura mexicana. Ubicado entre exuberantes manglares y canales tranquilos, cada una de sus 162 villas cuenta con una piscina privada climatizada, brindando a los huéspedes privacidad y confort incomparables.",
          imageUrl: "/images/ctr_banyantree_room.jpg",
          roomImageUrl: "https://www.banyantree.com/-/media/banyan-tree-images/mexico/mayakoba/gallery/btmxmy_beachfront_pool_suite_room_perspective.jpg",
          location: "Carretera Federal Chetumal-Puerto Juárez Km 298, Playa del Carmen, Quintana Roo, Mexico",
          rating: "5.0/5.0",
          features: [
            "Private Heated Pool Villas",
            "Award-Winning Banyan Tree Spa",
            "Gourmet Dining Experiences",
            "Eco-Friendly Resort Design",
            "Access to El Camaleón Golf Course"
          ]
        
      },
      {
        id: "grand-velas-riviera-maya",
        name: "Grand Velas Riviera Maya",
        name_es: "Grand Velas Riviera Maya",
        description: "A AAA Five Diamond, all-inclusive resort with exceptional service, sprawling beachfront, Michelin-level dining, and separate adults-only and family-friendly sections.",
        description_es: "Resort todo incluido AAA Cinco Diamantes con servicio excepcional, playa amplia, gastronomía de nivel Michelin y secciones solo adultos y familiares.",
        imageUrl: "/images/ctr_grandvelas.jpg",
        location: "Carretera Cancún Tulum Km 62, Playa del Carmen, Quintana Roo",
        rating: "4.9/5.0"
      },
      {
        id: "hotel-esencia",
        name: "Hotel Esencia",
        name_es: "Hotel Esencia",
        description: "A legendary boutique hotel on Xpu-Ha Beach, offering understated, barefoot luxury and total privacy on 50 acres of pristine jungle and sand. Just 45 rooms and suites, each with unique style and access to world-class service and spa.",
        description_es: "Un hotel boutique legendario en la playa Xpu-Ha que ofrece lujo discreto y privacidad total en 20 hectáreas de selva y arena prístina. Solo 45 habitaciones y suites con acceso a servicio y spa de clase mundial.",
        imageUrl: "/images/ctr_escenica_room.jpg",
        location: "Carretera Tulum-Cancún Km 265, Xpu-Ha, Quintana Roo",
        rating: "4.7/5.0"
      },

      {
          id: "la-valise-tulum",
          name: "La Valise Tulum",
          name_es: "La Valise Tulum",
          description: "An intimate, design-driven boutique hotel with just 11 unique suites—six facing the Caribbean and five nestled in the jungle. Enjoy indoor-outdoor showers, hand-crafted details, and Tulum's most exclusive rolling bed suites—sleep under the stars or wake to the sunrise. Perfect for privacy, luxury, and romance.",
          description_es: "Un hotel boutique íntimo y de diseño con solo 11 suites únicas—seis frente al Caribe y cinco en la selva. Disfruta de duchas interiores y exteriores, detalles artesanales y las exclusivas suites con cama rodante para dormir bajo las estrellas o despertar con el amanecer. Perfecto para privacidad, lujo y romance.",
          imageUrl: "/images/ctr_lavalise.jpg",
          roomImageUrl: "https://www.lavalise.com/wp-content/uploads/2022/09/La-Valise-Tulum-Hotel-Mexico-16.jpg",
          location: "Carretera Tulum-Boca Paila Km 8.7, Zona Hotelera, Tulum, Quintana Roo",
          rating: "4.8/5.0",
          features: [
            "Beachfront & Jungle Suites",
            "Exclusive Rolling Bed Suites",
            "Indoor-Outdoor Showers",
            "Personalized Service",
            "Adults-Oriented Privacy"
          ]
      }
      
    ],
    diningExperiences: [
      {
        name: "Le Chique",
        name_es: "Le Chique",
        description: "An innovative restaurant offering creative Mexican cuisine in a sophisticated setting.",
        description_es: "Un restaurante innovador que ofrece cocina mexicana creativa en un entorno sofisticado.",
        imageUrl: "/images/ctr_lechique.jpg",
        rating: "4.9/5.0"
      },
      {
        name: "Benazuza",
        name_es: "Benazuza",
        description: "A molecular gastronomy restaurant known for its creative dishes and unique dining experience.",
        description_es: "Un restaurante de gastronomía molecular conocido por sus platos creativos y experiencia culinaria única.",
        imageUrl: "/images/ctr_benazuza.jpg",
        rating: "4.8/5.0"
      },
      {
        name: "Puerto Madero",
        name_es: "Puerto Madero",
        description: "An elegant steakhouse offering premium cuts and fresh seafood with ocean views.",
        description_es: "Una elegante parrilla que ofrece cortes premium y mariscos frescos con vistas al océano.",
        imageUrl: "/images/ctr_puerto-madero.jpg",
        rating: "4.7/5.0"
      },
      {
        name: "Cocina de Autor (Grand Velas)",
        name_es: "Cocina de Autor (Grand Velas)",
        description: "An award-winning culinary journey featuring innovative tasting menus and artistic presentations.",
        description_es: "Un viaje culinario galardonado con menús degustación innovadores y presentaciones artísticas.",
        imageUrl: "/images/ctr_cocina_de_autor.jpg",
        rating: "4.9/5.0"
      },
      {
        name: "Casa del Lago (Rosewood Mayakoba)",
        name_es: "Casa del Lago (Rosewood Mayakoba)",
        description: "An elegant beachfront restaurant offering innovative seafood-focused cuisine with stunning ocean views.",
        description_es: "Un elegante restaurante frente al mar que ofrece una cocina innovadora centrada en mariscos con impresionantes vistas al océano.",
        imageUrl: "/images/ctr_casa_del_lago.jpg",
        rating: "4.8/5.0"
      },

      {
        name: "Saffron (Banyan Tree)",
        name_es: "Saffron (Banyan Tree)",
        description: "Authentic Thai cuisine in a romantic setting, featuring traditional flavors and modern techniques.",
        description_es: "Cocina tailandesa auténtica en un ambiente romántico, con sabores tradicionales y técnicas modernas.",
        imageUrl: "/images/ctr_saffron.jpg",
        rating: "4.8/5.0"
      }
    ]
  },
  {
    slug: 'mexico-city',
    title: 'Mexico City',
    title_es: 'Ciudad de México',
    desc: "Urban sophistication, cultural richness, world-class venues.",
    desc_es: "Sofisticación urbana, riqueza cultural, lugares de clase mundial.",
    image: '/images/mexicocity4-1200.jpg',
    heroImage: '/images/mexicocity4.jpg',
    magicImage: '/images/mexicocity2-1200.jpg',
    experienceImage: '/images/mexicocity12.jpg',
    footerSliverImage: '/images/mexicocity9.jpg',
    sectionImage: '/images/beach_seating.jpg',
    overview: "Mexico City is a vibrant metropolis that combines ancient history with modern sophistication, offering world-class venues and cultural experiences.",
    overview_es: "Ciudad de México es una metrópolis vibrante que combina historia antigua con sofisticación moderna, ofreciendo lugares de clase mundial y experiencias culturales.",
    weddingsDesc: "Weddings here blend urban elegance with cultural richness, offering everything from historic haciendas to modern rooftop venues.",
    weddingsDesc_es: "Las bodas aquí combinan elegancia urbana con riqueza cultural, ofreciendo desde haciendas históricas hasta lugares modernos en la azotea.",
    bestTime: 'October to May',
    bestTime_es: 'Octubre a Mayo',
    nearestAirport: 'Mexico City International Airport (MEX)',
    nearestAirport_es: 'Aeropuerto Internacional de la Ciudad de México (MEX)',
    airportInternational: 'Mexico City International Airport (MEX)',
    airportInternational_es: 'Aeropuerto Internacional de la Ciudad de México (MEX)',
    airportDomestic: 'Mexico City International Airport (MEX)',
    airportDomestic_es: 'Aeropuerto Internacional de la Ciudad de México (MEX)',
    airportPrivate: 'Mexico City International Airport (MEX)',
    airportPrivate_es: 'Aeropuerto Internacional de la Ciudad de México (MEX)',
    featuredVenues: [
      { name: 'General Prim', image: '/images/generalprim2.jpg' },
      { name: 'Parque Quetzalcóatl', image: '/images/quetzalcoatl.jpg' },
      { name: 'Ex Convento de San Hipólito', image: '/images/san-hipolito.jpg' },
    ],
    localTouch: "Experience world-class dining, explore historic neighborhoods, and enjoy rooftop celebrations with city views.",
    localTouch_es: "Vive gastronomía de clase mundial, explora barrios históricos y disfruta celebraciones en la azotea con vistas a la ciudad.",
    topActivities: [
      'Art gallery tour',
      'Rooftop dining',
      'Historic center tour',
      'Spa treatments',
      'Shopping',
      'Cultural experiences'
    ],
    topActivities_es: [
      'Tour de galerías de arte',
      'Cena en la azotea',
      'Tour del centro histórico',
      'Tratamientos de spa',
      'Compras',
      'Experiencias culturales'
    ],
    magicExperience: `Mexico City is where ancient traditions meet modern sophistication. From the moment you arrive, you're immersed in a world where colonial architecture stands alongside contemporary design, and cultural heritage blends with urban innovation. Picture historic plazas filled with life, elegant haciendas transformed into luxury venues, and rooftop terraces offering panoramic views of the city's iconic skyline. Here, every celebration becomes a perfect blend of tradition and modernity.`,
    magicExperience_es: `Ciudad de México es donde las tradiciones antiguas se encuentran con la sofisticación moderna. Desde el momento en que llegas, te sumerges en un mundo donde la arquitectura colonial se alza junto al diseño contemporáneo, y la herencia cultural se mezcla con la innovación urbana. Visualiza plazas históricas llenas de vida, haciendas elegantes transformadas en lugares de lujo y terrazas en la azotea que ofrecen vistas panorámicas del icónico horizonte de la ciudad. Aquí, cada celebración se convierte en una mezcla perfecta de tradición y modernidad.`,
    vibe: `Mexico City radiates an atmosphere of sophisticated energy and cultural richness. Days begin with café con leche in historic cafés, followed by gallery visits and leisurely strolls through colonial streets. As the sun sets, the city transforms into a celebration of life, with rooftop bars offering panoramic views, live music filling the air, and candlelit dinners featuring the region's famous cuisine. Every moment here feels curated, every experience authentic, and every celebration infused with the magic of this cultural capital.`,
    vibe_es: `Ciudad de México irradia una atmósfera de energía sofisticada y riqueza cultural. Los días comienzan con café con leche en cafés históricos, seguidas de visitas a galerías y paseos por calles coloniales. Al caer el sol, la ciudad se transforma en una celebración de la vida, con bares en la azotea que ofrecen vistas panorámicas, música en vivo llenando el aire y cenas iluminadas por velas con la famosa cocina de la región. Cada momento aquí se siente curado, cada experiencia auténtica y cada celebración impregnada con la magia de esta capital cultural.`,
    climateSeasons: `From October to May, Mexico City enjoys perfect weather with warm days, cool nights, and minimal rainfall—ideal for outdoor celebrations and exploring the city. The dry season brings out the region's dramatic beauty, while summer offers lush landscapes and a festive spirit.`,
    climateSeasons_es: `De octubre a mayo, Ciudad de México disfruta de un clima perfecto con días cálidos, noches frescas y lluvias mínimas—ideal para celebraciones al aire libre y explorar la ciudad. La temporada seca resalta la belleza dramática de la región, mientras que el verano ofrece paisajes exuberantes y un espíritu festivo.`,
    accessibilityDetails: `Mexico City is easily accessible through Mexico City International Airport (MEX), which offers numerous direct flights from major cities worldwide. Upon arrival, the city's extensive metro system, taxis, and ride-sharing services make it easy to navigate. Many hotels offer private transportation services, and the city's well-maintained infrastructure ensures smooth travel throughout.`,
    accessibilityDetails_es: `Ciudad de México es fácilmente accesible a través del Aeropuerto Internacional de la Ciudad de México (MEX), que ofrece numerosos vuelos directos desde las principales ciudades del mundo. Al llegar, el extenso sistema de metro de la ciudad, taxis y servicios de transporte compartido facilitan la navegación. Muchos hoteles ofrecen servicios de transporte privado, y la infraestructura bien mantenida de la ciudad garantiza un viaje sin problemas.`,
    experienceBlurb: 'From exploring historic neighborhoods to enjoying world-class dining with city views,',
    experienceBlurb_es: 'De explorar barrios históricos a disfrutar de gastronomía de clase mundial con vistas a la ciudad,',
    weddingVenues: [
      "general-prim-mexico-city",
      "parque-quetzalcoatl-mexico-city",
      "ex-convento-san-hipolito-mexico-city",
      "colegio-vizcainas-mexico-city",
      "jardin-huayacan-mexico-city",
      "jardin-rancho-la-pena-mexico-city"
    ],
    bestWeddingVenues: [
      "general-prim-mexico-city",
      "parque-quetzalcoatl-mexico-city",
      "ex-convento-san-hipolito-mexico-city",
      "colegio-vizcainas-mexico-city",
      "jardin-huayacan-mexico-city",
      "jardin-rancho-la-pena-mexico-city",
      "four-seasons-mexico-city",
      "st-regis-mexico-city",
      "hotel-condesa-df",
      "casa-polanco",
      "hotel-brick"
    ],
    hotelsResortsStays: [
      {
        id: "four-seasons-mexico-city",
        name: "Four Seasons Hotel Mexico City",
        name_es: "Hotel Four Seasons Ciudad de México",
        description: "A luxury hotel set in a historic building, offering stunning views of the city and exceptional service. The elegant ballrooms and rooftop spaces provide the perfect setting for sophisticated celebrations.",
        description_es: "Un hotel de lujo ubicado en un edificio histórico, que ofrece impresionantes vistas de la ciudad y servicio excepcional. Los elegantes salones y espacios en la azotea proporcionan el escenario perfecto para celebraciones sofisticadas.",
        imageUrl: "/images/mexico_fourseasons.jpg",
        rating: "5.0/5.0",
        features: ["Luxury", "Historic", "City View", "Spa", "Fine Dining", "Butler Service", "Rooftop"]
      },
      {
        id: "st-regis-mexico-city",
        name: "St. Regis Mexico City",
        name_es: "St. Regis Ciudad de México",
        description: "A sophisticated hotel known for its elegant design, exceptional service, and stunning city views. The grand ballrooms and rooftop venues offer versatile spaces for memorable celebrations.",
        description_es: "Un hotel sofisticado conocido por su diseño elegante, servicio excepcional e impresionantes vistas de la ciudad. Los grandiosos salones y lugares en la azotea ofrecen espacios versátiles para celebraciones memorables.",
        imageUrl: "/images/mexico_stregis.jpg",
        rating: "5.0/5.0",
        features: ["Luxury", "Modern", "City View", "Spa", "Fine Dining", "Butler Service", "Rooftop"]
      },
      {
        "name": "Hotel Volga",
        "name_es": "Hotel Volga",
        "description": "A sophisticated boutique hotel in Cuauhtémoc, blending brutalist architecture with minimalist interiors, featuring curated art installations, a rooftop pool, and the Mediterranean restaurant Elora by Edo Kobayashi.",
        "description_es": "Un sofisticado hotel boutique en Cuauhtémoc que combina arquitectura brutalista con interiores minimalistas, cuenta con instalaciones de arte curadas, una piscina en la azotea y el restaurante mediterráneo Elora de Edo Kobayashi.",
        "imageUrl": "/images/mexico_volga.jpg",
        "rating": "4.9/5.0"
      },
      {
        id: "casa-polanco",
        name: "Casa Polanco",
        name_es: "Casa Polanco",
        description: "An exclusive boutique hotel in the upscale Polanco neighborhood, offering personalized service and sophisticated design. The elegant spaces and beautiful gardens provide a refined setting for intimate celebrations.",
        description_es: "Un exclusivo hotel boutique en el elegante barrio de Polanco, que ofrece servicio personalizado y diseño sofisticado. Los espacios elegantes y hermosos jardines proporcionan un ambiente refinado para celebraciones íntimas.",
        imageUrl: "/images/mexico_casapolanco.jpg",
        rating: "4.9/5.0",
        features: ["Boutique", "Elegant", "Garden", "Restaurant", "Bar", "Spa"]
      },
      {
        "name": "Nima Local House Hotel & Spa",
        "name_es": "Nima Local House Hotel & Spa",
        "description": "An intimate boutique hotel in Roma Norte, offering four uniquely decorated rooms, personalized service, and a serene ambiance in a restored early 20th-century mansion.",
        "description_es": "Un hotel boutique íntimo en Roma Norte, que ofrece cuatro habitaciones decoradas de forma única, servicio personalizado y un ambiente sereno en una mansión restaurada de principios del siglo XX.",
        "imageUrl": "/images/mexico_nima.jpg",
        "rating": "5.0/5.0"
      },
      {
        "name": "Sofitel Mexico City Reforma",
        "name_es": "Sofitel Ciudad de México Reforma",
        "description": "A stylish French luxury hotel with contemporary rooms, a sky-high pool, and top dining in a prime Reforma location.",
        "description_es": "Un elegante hotel de lujo francés con habitaciones contemporáneas, piscina elevada y excelente gastronomía en una ubicación privilegiada de Reforma.",
        "imageUrl": "/images/mexico_sofitel.jpg",
        "rating": "5.0/5.0"
      }
    ],
    diningExperiences: [
      {
        name: "Pujol",
        name_es: "Pujol",
        description: "One of the world's most celebrated restaurants, offering innovative Mexican cuisine in an elegant setting.",
        description_es: "Uno de los restaurantes más celebrados del mundo, que ofrece cocina mexicana innovadora en un entorno elegante.",
        imageUrl: "/images/pujol.jpg",
        rating: "4.9/5.0"
      },
      {
        name: "Quintonil",
        name_es: "Quintonil",
        description: "A sophisticated restaurant known for its creative interpretation of traditional Mexican flavors.",
        description_es: "Un restaurante sofisticado conocido por su interpretación creativa de sabores tradicionales mexicanos.",
        imageUrl: "/images/quintonil.jpg",
        rating: "4.8/5.0"
      },
      {
        name: "Ling Ling",
        name_es: "Ling Ling",
        description: "A sophisticated Asian fusion restaurant offering innovative cuisine and stunning city views.",
        description_es: "Un sofisticado restaurante de fusión asiática que ofrece cocina innovadora e impresionantes vistas de la ciudad.",
        imageUrl: "/images/mexico_lingling.jpg",
        rating: "4.8/5.0"
      },
      {
        name: "Animal St. Regis",
        name_es: "Animal St. Regis",
        description: "A contemporary restaurant known for its creative dishes and elegant atmosphere in the heart of the city.",
        description_es: "Un restaurante contemporáneo conocido por sus platos creativos y ambiente elegante en el corazón de la ciudad.",
        imageUrl: "/images/animal.jpg",
        rating: "4.8/5.0"
      },
      {
        name: "Auna",
        name_es: "Auna",
        description: "A sophisticated restaurant offering innovative Mexican cuisine with a focus on seasonal ingredients and creative presentations.",
        description_es: "Un restaurante sofisticado que ofrece cocina mexicana innovadora con un enfoque en ingredientes de temporada y presentaciones creativas.",
        imageUrl: "/images/auna.jpg",
        rating: "4.8/5.0"
      },
      {
        name: "Contramar",
        name_es: "Contramar",
        description: "A beloved seafood restaurant known for its fresh fish and vibrant atmosphere.",
        description_es: "Un querido restaurante de mariscos conocido por su pescado fresco y ambiente vibrante.",
        imageUrl: "/images/contramar.jpg",
        rating: "4.8/5.0"
      }
    ]
  },
  {
    slug: 'los-cabos',
    title: 'Los Cabos',
    title_es: 'Los Cabos',
    desc: "Dramatic coastlines, desert beauty, exclusive venues.",
    desc_es: "Costas dramáticas, belleza desértica, lugares exclusivos.",
    image: '/images/cabo3.jpg',
    heroImage: '/images/cabo5-1200.jpg',
    magicImage: '/images/cabo4.jpg',
    footerSliverImage: '/images/cabo2-1600.jpg',
    sectionImage: '/images/beach_seating.jpg',
    overview: "Los Cabos is where the desert meets the sea, with dramatic cliffs, luxury resorts, and endless sunshine.",
    overview_es: "Los Cabos es donde el desierto se encuentra con el mar, con acantilados dramáticos, resorts de lujo y sol interminable.",
    weddingsDesc: "Weddings in Los Cabos are glamorous and exclusive, with private villas, cliffside ceremonies, and world-class service.",
    weddingsDesc_es: "Las bodas en Los Cabos son glamurosas y exclusivas, con villas privadas, ceremonias en acantilados y servicio de clase mundial.",
    bestTime: 'November to June',
    bestTime_es: 'Noviembre a Junio',
    nearestAirport: 'Los Cabos International Airport (SJD)',
    nearestAirport_es: 'Aeropuerto Internacional de Los Cabos (SJD)',
    airportInternational: 'Los Cabos International Airport (SJD)',
    airportInternational_es: 'Aeropuerto Internacional de Los Cabos (SJD)',
    airportDomestic: 'Los Cabos International Airport (SJD)',
    airportDomestic_es: 'Aeropuerto Internacional de Los Cabos (SJD)',
    airportPrivate: 'Aeropuerto de Cabo San Lucas (CSL)',
    airportPrivate_es: 'Aeropuerto de Cabo San Lucas (CSL)',
    featuredVenues: [
      { name: 'The Cape', image: 'https://assets.milestoneinternet.com/cdn-cgi/image/f=auto/grand-velas-parent/rivieramayagrandvelas-new/mainimages/background-wedding-gvrm.jpg?width=1920&height=650' },
      { name: 'Esperanza', image: 'https://assets.milestoneinternet.com/cdn-cgi/image/f=auto/grand-velas-parent/rivieramayagrandvelas-new/mainimages/background-wedding-gvrm.jpg?width=1920&height=650' },
      { name: 'Flora Farms', image: 'https://acreresort.com/gallery' },
    ],
    localTouch: "Host a beach bonfire, enjoy farm-to-table feasts, and explore the iconic Arch.",
    localTouch_es: "Organiza una fogata en la playa, disfruta de cenas de la granja a la mesa y explora el icónico Arco.",
    topActivities: [
      'Boat tour to El Arco',
      'Beach bonfire',
      'Snorkeling',
      'Golf',
      'Whale watching (in season)',
      'Luxury spa day'
    ],
    topActivities_es: [
      'Tour en barco al Arco',
      'Fogata en la playa',
      'Snorkel',
      'Golf',
      'Avistamiento de ballenas (en temporada)',
      'Día de spa de lujo'
    ],
    magicExperience: `Where the desert meets the sea, Los Cabos dazzles with dramatic cliffs, endless sunshine, and the ever-changing blues of the Pacific. From the moment you land, the stunning convergence of the Pacific Ocean and dramatic desert landscapes ushers you into a celebration like no other. Picture private villas perched above golden beaches, waves crashing against ancient rock formations, and sunsets that set the sky ablaze. Here, luxury is effortless—days are spent sailing, savoring fresh ceviche, and basking in the glow of a celebration that feels both glamorous and wild.`,
    magicExperience_es: `Donde el desierto se encuentra con el mar, Los Cabos deslumbra con acantilados dramáticos, sol interminable y los azules cambiantes del Pacífico. Imagina villas privadas sobre playas doradas, olas rompiendo en formaciones rocosas y atardeceres que encienden el cielo. Aquí, el lujo es natural: los días se disfrutan navegando, saboreando ceviche fresco y celebrando en un ambiente tan glamuroso como salvaje.`,
    vibe: `Los Cabos is the epitome of coastal chic—glamorous, exclusive, and alive with possibility. Mornings begin with ocean breezes and yoga on the sand; afternoons bring poolside cocktails and adventures along the coast. As night falls, the energy shifts to candlelit dinners, rooftop parties, and dancing beneath the stars. Every detail is elevated, every guest indulged, and every moment infused with the magic of the Baja.`,
    vibe_es: `Los Cabos es la definición de sofisticación costera—glamuroso, exclusivo y lleno de posibilidades. Las mañanas comienzan con brisas marinas y yoga en la arena; las tardes traen cocteles junto a la alberca y aventuras por la costa. Al caer la noche, la energía se transforma en cenas a la luz de las velas, fiestas en azoteas y bailes bajo las estrellas. Cada detalle se eleva, cada invitado se consiente y cada momento está impregnado de la magia de Baja.`,
    climateSeasons: `From November to June, Los Cabos enjoys endless sunshine, gentle breezes, and virtually no rain—ideal for beachside ceremonies and starlit celebrations. The dry season brings out the region's dramatic beauty, while summer offers vibrant landscapes and a festive spirit.`,
    climateSeasons_es: `De noviembre a junio, Los Cabos disfruta de sol interminable, brisas suaves y prácticamente sin lluvia—ideal para ceremonias junto al mar y celebraciones bajo las estrellas. La temporada seca resalta la belleza dramática de la región, mientras que el verano ofrece paisajes vibrantes y un espíritu festivo.`,
    accessibilityDetails: `Los Cabos offers unmatched accessibility, with direct flights from major U.S., Canadian, and international cities. Upon landing at Los Cabos International Airport (SJD), your seamless journey to world-class resorts begins, with a comfortable and scenic transfer to your chosen retreat. Whether celebrating in lively Cabo San Lucas, historic San José del Cabo, or beyond, guests will enjoy an easy, effortless arrival.`,
    accessibilityDetails_es: `Los Cabos ofrece acceso inigualable, con vuelos directos desde ciudades principales de EE. UU., Canadá y otros destinos. Al aterrizar en el Aeropuerto Internacional de Los Cabos (SJD), la transición a los resorts de clase mundial es rápida y cómoda. Ya sea en Cabo San Lucas, San José del Cabo o más allá, los invitados disfrutarán de una llegada fácil y sin complicaciones.`,
    experienceBlurb: 'From sailing past the iconic Arch at Land\'s End to savoring fresh ceviche on sun-drenched beaches,',
    experienceBlurb_es: 'De navegar junto al icónico Arco hasta saborear ceviche fresco en playas bañadas por el sol,',
    weddingVenues: [
      "esperanza-auberge",
      "one-only-palmilla",
      "waldorf-astoria-pedregal",
      "the-cape-thompson",
      "flora-farms",
      "montage-los-cabos"
    ],
    bestWeddingVenues: [
      "esperanza-auberge",
      "one-only-palmilla",
      "waldorf-astoria-pedregal",
      "the-cape-thompson",
      "flora-farms",
      "montage-los-cabos"
    ],
    hotelsResortsStays: [
      {
        name: "Esperanza, Auberge Resorts Collection",
        name_es: "Esperanza, Colección Auberge Resorts",
        description: "An ultra-luxury, cliffside sanctuary offering highly personalized service, stunning ocean views, and unparalleled serenity.",
        description_es: "Un santuario ultra-lujoso en acantilado que ofrece servicio altamente personalizado, impresionantes vistas al océano y una serenidad sin igual.",
        imageUrl: "https://dreffui1gbt6t.cloudfront.net/images/esp/esp-categories-casonas.jpg",
        rating: "5.0/5.0"
      },
      {
        name: "Waldorf Astoria Los Cabos Pedregal",
        name_es: "Waldorf Astoria Los Cabos Pedregal",
        description: "A secluded paradise carved into a cliff, offering stunning ocean views from private plunge pools, direct beach access, and unparalleled privacy.",
        description_es: "Un paraíso aislado tallado en un acantilado, que ofrece impresionantes vistas al océano desde piscinas privadas, acceso directo a la playa y privacidad sin igual.",
        imageUrl: "https://cdn.waldorfastorialoscabospedregal.com/wp-content/uploads/2021/10/14032259/WAPedregal-High-Res-Three-Bedroom-Ocean-View-Suite-Plunge-Pool-5-1.jpg",
        rating: "5.0/5.0"
      },
      {
        name: "One&Only Palmilla",
        name_es: "One&Only Palmilla",
        description: "A legendary luxury resort known for its exquisite service, timeless architecture, and serene ambiance amidst lush tropical gardens and pristine beaches.",
        description_es: "Un resort de lujo legendario conocido por su servicio exquisito, arquitectura atemporal y ambiente sereno entre exuberantes jardines tropicales y playas prístinas.",
        imageUrl: "https://assets.kerzner.com/api/public/content/89a932f4e72342edae284478ca9eae04?v=96f8c1a0&t=w992",
        rating: "5.0/5.0"
      },
      {
        name: "The Cape, a Thompson Hotel",
        name_es: "The Cape, un Hotel Thompson",
        description: "A modern architectural masterpiece offering panoramic ocean views and a sophisticated atmosphere with exceptional service.",
        description_es: "Una obra maestra arquitectónica moderna que ofrece vistas panorámicas al océano y una atmósfera sofisticada con servicio excepcional.",
        imageUrl: "/images/loscabos_thecape.jpg",
        rating: "4.8/5.0"
      },
      {
        name: "Montage Los Cabos",
        name_es: "Montage Los Cabos",
        description: "An exclusive beachfront resort offering unparalleled luxury and privacy with world-class amenities and exceptional service.",
        description_es: "Un exclusivo resort frente al mar que ofrece lujo y privacidad sin igual con comodidades de clase mundial y servicio excepcional.",
        imageUrl: "https://uploads.montage.com/uploads/sites/7/2021/01/11113041/Dise%C3%B1o-sin-t%C3%ADtulo-4.jpg",
        rating: "5.0/5.0"
      },
      {
        name: "Flora Farms",
        name_es: "Flora Farms",
        description: "A unique organic farm setting offering a rustic yet sophisticated atmosphere with farm-to-table dining and lush gardens.",
        description_es: "Un entorno único de granja orgánica que ofrece una atmósfera rústica pero sofisticada con gastronomía de la granja a la mesa y jardines exuberantes.",
        imageUrl: "https://bookingenginecdn.hostaway.com/listing/136089-370953-8Y1MTRuLBjiwfMZwHsw4OhZMx5J1UnxdSmu-xdilo4w-67d320f3da2f5?width=2560&quality=70&format=webp&v=2",
        rating: "4.7/5.0"
      }
    ],
    diningExperiences: [
      {
        name: "El Farallon",
        name_es: "El Farallon",
        description: "A spectacular restaurant carved into the cliffs of Los Cabos, where the sound of crashing waves and the ocean breeze set the stage for a truly unique culinary experience. Farallón features the freshest seafood and daily catches, hand-selected on the spot, while panoramic ocean views and golden sunset light create a magical, unforgettable atmosphere. Perfect for romantic dinners or special celebrations by the sea.",
        description_es: "Un restaurante espectacular enclavado en los acantilados de Los Cabos, donde el sonido de las olas y la brisa marina acompañan una experiencia culinaria única. Farallón ofrece mariscos frescos y pescados del día, seleccionados al instante, mientras las vistas panorámicas al océano y la luz dorada del atardecer crean un ambiente mágico e inolvidable. Ideal para cenas románticas o celebraciones especiales junto al mar.",
        imageUrl: "https://cdn.waldorfastorialoscabospedregal.com/wp-content/uploads/2021/11/14025904/rsz_1wa_pedregal_air_view_blake_marvin_high_res-scaled-1-1440x1268.webp",
        rating: "4.8/5.0"
      },
      {
        name: "Flora's Field Kitchen",
        name_es: "Flora's Field Kitchen",
        description: "Flora's Field Kitchen is a lively farm restaurant known for wood-fired dishes, house-baked breads, and a welcoming, communal atmosphere. It's where fresh flavors and good company come together under the Baja sun.",
        description_es: "Flora's Field Kitchen es un restaurante de granja animado, famoso por sus platillos al horno de leña, panes artesanales y ambiente acogedor. Aquí, los sabores frescos y la buena compañía se disfrutan bajo el sol de Baja.",
        imageUrl: "https://images.squarespace-cdn.com/content/v1/59307e96f5e231d2d07636f7/e26c4957-09e2-4cda-816a-c81d5e89cd2f/Flora%2B-%2B06.jpg?format=800w",
        rating: "4.6/5.0"
      },
      {
        name: "Acre",
        name_es: "Acre",
        description: "Acre Restaurant in San José del Cabo is an unforgettable dining destination, set within lush palm groves on a working farm. Enjoy vibrant, globally inspired dishes crafted from ingredients grown right on the property, all in a beautiful open-air setting. Recognized with a MICHELIN Green Star, Acre delivers an exceptional culinary experience where sustainability and style meet in the heart of Baja.",
        description_es: "Acre Restaurant en San José del Cabo es un destino culinario único, rodeado de palmeras y naturaleza en una finca activa. Disfruta de platillos creativos y llenos de sabor, elaborados con ingredientes frescos de la propia huerta, en un ambiente abierto y elegante. Reconocido con una Estrella Verde MICHELIN, Acre combina sostenibilidad, alta cocina y estilo en el corazón de Baja California Sur.",
        imageUrl: "https://acreresort.com/wp-content/uploads/2025/02/acre-resort-restaurant-food-13.jpg",
        rating: "4.9/5.0"
      },

      {
        name: "Comal",
        name_es: "Comal",
        description: "Comal is a sophisticated restaurant where contemporary Mexican flavors meet artful presentation and fresh local ingredients. With open-air, oceanside seating and dreamy views of the Sea of Cortez, every meal feels like a romantic escape—perfect for unforgettable evenings by the water.",
        description_es: "Comal es un restaurante sofisticado que fusiona sabores mexicanos contemporáneos con presentaciones artísticas e ingredientes frescos. Con mesas al aire libre frente al mar y vistas de ensueño al Mar de Cortés, cada comida se convierte en una escapada romántica, ideal para noches inolvidables junto al agua.",
        imageUrl: "https://axwwgrkdco.cloudimg.io/v7/__gmpics3__/2b2f829d62fe4236a1f57bafc6c2bfb7.jpg?width=1000",
        rating: "4.8/5.0"
      },
      {
        name: "Manta",
        name_es: "Manta",
        description: "A sophisticated restaurant offering innovative Mexican and Asian fusion cuisine with ocean views.",
        description_es: "Un restaurante sofisticado que ofrece cocina fusión mexicana y asiática innovadora con vistas al océano.",
        imageUrl: "/images/cabo_manta_restaurant.jpg",
        rating: "4.9/5.0"
      },
      {
        name: "Cocina del Mar",
        name_es: "Cocina del Mar",
        description: "Cocina del Mar is the signature oceanfront restaurant at Esperanza Resort in Cabo San Lucas. Set on dramatic cliffs overlooking the Sea of Cortez, it offers fresh seafood and Baja-inspired cuisine in a stunning, open-air setting.",
        description_es: "Cocina del Mar es el restaurante principal frente al mar del resort Esperanza en Cabo San Lucas. Ubicado sobre acantilados con vistas al Mar de Cortés, ofrece mariscos frescos y cocina inspirada en Baja en un entorno abierto y espectacular.",
        imageUrl: "https://dreffui1gbt6t.cloudfront.net/images/esp/esp-dine-cocinadelmar-slider-1-23.jpg",
        rating: "4.8/5.0"
      }
    ],
    bestTimeAndClimate: 'The best time to get married here is November to June. From November to June, Los Cabos enjoys endless sunshine, gentle breezes, and virtually no rain—ideal for beachside ceremonies and starlit celebrations. The dry season brings out the region\'s dramatic beauty, while summer offers vibrant landscapes and a festive spirit.',
    bestTimeAndClimate_es: 'La mejor época para casarse aquí es Noviembre a Junio. De noviembre a junio, Los Cabos disfruta de sol interminable, brisas suaves y prácticamente sin lluvia—ideal para ceremonias junto al mar y celebraciones bajo las estrellas. La temporada seca resalta la belleza dramática de la región, mientras que el verano ofrece paisajes vibrantes y un espíritu festivo.'
  },
  {
    slug: 'san-miguel-de-allende',
    title: 'San Miguel de Allende',
    title_es: 'San Miguel de Allende',
    desc: "Colonial charm, artistic spirit, romantic venues.",
    desc_es: "Encanto colonial, espíritu artístico, lugares románticos.",
    image: '/images/sanmiguel5.jpg',
    heroImage: '/images/sanmiguel6.jpg',
    magicImage: '/images/sanmiguel9.jpg',
    experienceImage: '/images/sanmiguel8_rosewood.jpg',
    footerSliverImage: '/images/sanmiguel12.jpg',
    sectionImage: '/images/beach_seating.jpg',
    overview: "San Miguel de Allende is a UNESCO World Heritage site known for its colonial architecture, vibrant arts scene, and romantic atmosphere.",
    overview_es: "San Miguel de Allende es un sitio Patrimonio de la Humanidad por la UNESCO conocido por su arquitectura colonial, vibrante escena artística y atmósfera romántica.",
    weddingsDesc: "Weddings here blend colonial elegance with artistic flair, offering historic venues and romantic settings.",
    weddingsDesc_es: "Las bodas aquí combinan la elegancia colonial con el estilo artístico, ofreciendo lugares históricos y entornos románticos.",
    bestTime: 'October to May',
    bestTime_es: 'Octubre a Mayo',
    nearestAirport: 'Querétaro International Airport (QRO)',
    nearestAirport_es: 'Aeropuerto Internacional de Querétaro (QRO)',
    airportInternational: 'Querétaro International Airport (QRO)',
    airportInternational_es: 'Aeropuerto Internacional de Querétaro (QRO)',
    airportDomestic: 'Querétaro International Airport (QRO)',
    airportDomestic_es: 'Aeropuerto Internacional de Querétaro (QRO)',
    airportPrivate: 'Querétaro International Airport (QRO)',
    airportPrivate_es: 'Aeropuerto Internacional de Querétaro (QRO)',
    featuredVenues: [
      { name: 'Rosewood San Miguel de Allende', image: '/images/rosewood-sma.jpg' },
      { name: 'Belmond Casa de Sierra Nevada', image: '/images/belmond.jpg' },
      { name: 'Matilda Hotel', image: '/images/matilda.jpg' },
    ],
    localTouch: "Explore art galleries, enjoy rooftop cocktails, and experience traditional Mexican culture.",
    localTouch_es: "Explora galerías de arte, disfruta de cócteles en la azotea y vive la cultura tradicional mexicana.",
    topActivities: [
      'Art gallery tour',
      'Rooftop dining',
      'Hot air balloon ride',
      'Spa treatments',
      'Cooking class',
      'Wine tasting'
    ],
    topActivities_es: [
      'Tour de galerías de arte',
      'Cena en la azotea',
      'Paseo en globo aerostático',
      'Tratamientos de spa',
      'Clase de cocina',
      'Cata de vinos'
    ],
    magicExperience: `San Miguel de Allende is a masterpiece of colonial architecture and artistic inspiration. From the moment you arrive, you're transported to a world where time seems to stand still, yet creativity flows freely. Picture cobblestone streets lined with colorful facades, hidden courtyards filled with blooming bougainvillea, and rooftop terraces offering panoramic views of the city's iconic spires. Here, every corner tells a story, every plaza invites celebration, and every moment feels like a work of art.`,
    magicExperience_es: `San Miguel de Allende es una obra maestra de arquitectura colonial e inspiración artística. Desde el momento en que llegas, te transportas a un mundo donde el tiempo parece detenerse, pero la creatividad fluye libremente. Imagina calles empedradas bordeadas de fachadas coloridas, patios ocultos llenos de buganvillas florecientes y terrazas en la azotea que ofrecen vistas panorámicas de las icónicas agujas de la ciudad. Aquí, cada esquina cuenta una historia, cada plaza invita a la celebración y cada momento se siente como una obra de arte.`,
    vibe: `San Miguel de Allende radiates an atmosphere of sophisticated charm and artistic energy. Days begin with café con leche in historic plazas, followed by gallery visits and leisurely strolls through colonial streets. As the sun sets, the city transforms into a romantic wonderland, with candlelit courtyards, live music floating through the air, and rooftop bars offering the perfect setting for celebration. Every detail here feels curated, every experience authentic, and every moment infused with the magic of this UNESCO World Heritage site.`,
    vibe_es: `San Miguel de Allende irradia una atmósfera de encanto sofisticado y energía artística. Los días comienzan con café con leche en plazas históricas, seguidas de visitas a galerías y paseos por calles coloniales. Al caer el sol, la ciudad se transforma en un país de las maravillas romántico, con patios iluminados por velas, música en vivo flotando en el aire y bares en la azotea que ofrecen el escenario perfecto para la celebración. Cada detalle aquí se siente curado, cada experiencia auténtica y cada momento impregnado con la magia de este sitio Patrimonio de la Humanidad por la UNESCO.`,
    climateSeasons: `From October to May, San Miguel de Allende enjoys perfect weather with warm days, cool nights, and minimal rainfall—ideal for outdoor celebrations and exploring the city. The dry season brings out the region's dramatic beauty, while summer offers lush landscapes and a festive spirit.`,
    climateSeasons_es: `De octubre a mayo, San Miguel de Allende disfruta de un clima perfecto con días cálidos, noches frescas y lluvias mínimas—ideal para celebraciones al aire libre y explorar la ciudad. La temporada seca resalta la belleza dramática de la región, mientras que el verano ofrece paisajes exuberantes y un espíritu festivo.`,
    accessibilityDetails: `San Miguel de Allende is easily accessible through Querétaro International Airport (QRO), which offers numerous direct flights from major cities across Mexico and the US. Upon arrival, the city is just a short transfer away, with many hotels offering private transportation services. The region's well-maintained highway system makes it easy to explore the surrounding areas, from the historic center to the scenic countryside.`,
    accessibilityDetails_es: `San Miguel de Allende es fácilmente accesible a través del Aeropuerto Internacional de Querétaro (QRO), que ofrece numerosos vuelos directos desde las principales ciudades de México y EE. UU. Al llegar, la ciudad está a solo un corto traslado, con muchos hoteles ofreciendo servicios de transporte privado. El sistema de carreteras bien mantenido de la región facilita la exploración de las áreas circundantes, desde el centro histórico hasta el campo pintoresco.`,
    experienceBlurb: 'From exploring art galleries to enjoying rooftop cocktails with panoramic city views,',
    experienceBlurb_es: 'De explorar galerías de arte a disfrutar de cócteles en la azotea con vistas panorámicas,',
    weddingVenues: [
      "rosewood-san-miguel",
      "casa-chorro",
      "hacienda-san-jose-lavista",
      "agua-bendita-sma",
      "casa-adela",

      "luna-escondida-sma"
    ],
    bestWeddingVenues: [
      "rosewood-san-miguel",
      "agua-bendita-sma",
      "luna-escondida-sma",
      "hacienda-san-jose-lavista",
      "casa-adela",
      "casa-chorro",

    ],
    hotelsResortsStays: [
      {
        id: "rosewood-sma",
        name: "Rosewood San Miguel de Allende",
        name_es: "Rosewood San Miguel de Allende",
        description: "A luxurious hacienda-style resort with colonial architecture, lush gardens, a world-class spa, and panoramic rooftop views over San Miguel.",
        description_es: "Un lujoso resort estilo hacienda con arquitectura colonial, jardines exuberantes, un spa de clase mundial y vistas panorámicas en la azotea.",
        imageUrl: "/images/sma_rosewood.jpg",
        location: "Nemesio Diez 11, Centro, San Miguel de Allende, Guanajuato",
        rating: "5.0/5.0",
        features: ["Spa", "Rooftop Bar", "Gourmet Dining", "Pool", "Luxury"]
      },
      {
        id: "belmond-casa-sierra-nevada-sma",
        name: "Casa de Sierra Nevada, A Belmond Hotel",
        name_es: "Casa de Sierra Nevada, A Belmond Hotel",
        description: "Set across historic mansions, this Belmond hotel offers elegant rooms, courtyards, lush gardens, and renowned cuisine in the heart of San Miguel.",
        description_es: "Ubicado en mansiones históricas, este hotel Belmond ofrece habitaciones elegantes, patios, jardines y gastronomía reconocida en el corazón de San Miguel.",
        imageUrl: "/images/sma_belmond.jpg",
        location: "Hospicio 35, Centro, San Miguel de Allende, Guanajuato",
        rating: "5.0/5.0",
        features: ["Historic", "Courtyard", "Cooking School", "Luxury"]
      },
      {
        id: "hotel-matilda-sma",
        name: "Hotel Matilda",
        name_es: "Hotel Matilda",
        description: "A chic, contemporary hotel with a modern art collection, a celebrated spa, vibrant pool scene, and fine dining restaurant.",
        description_es: "Un hotel chic y contemporáneo con una colección de arte moderno, spa reconocido, vibrante piscina y restaurante de alta cocina.",
        imageUrl: "/images/sma_matilda.jpg",
        location: "Aldama 53, Centro, San Miguel de Allende, Guanajuato",
        rating: "4.9/5.0",
        features: ["Contemporary", "Spa", "Art Collection", "Pool"]
      },
      {
        id: "la-valise-sma",
        name: "La Valise San Miguel",
        name_es: "La Valise San Miguel",
        description: "An intimate boutique hotel with unique suites blending Mexican artistry and modern luxury, set in a tranquil courtyard.",
        description_es: "Un hotel boutique íntimo con suites únicas que combinan arte mexicano y lujo moderno en un patio tranquilo.",
        imageUrl: "/images/sma_lavalise.jpg",
        location: "Aldama 41, Centro, San Miguel de Allende, Guanajuato",
        rating: "4.9/5.0",
        features: ["Boutique", "Artisanal Design", "Luxury Suites"]
      },
      {
        id: "live-aqua-sma",
        name: "Live Aqua San Miguel de Allende",
        name_es: "Live Aqua San Miguel de Allende",
        description: "A stylish, modern resort with artistic decor, luxury rooms, a top-tier spa, and several acclaimed restaurants and bars.",
        description_es: "Un resort moderno y elegante con decoración artística, habitaciones lujosas, un spa de primer nivel y reconocidos restaurantes y bares.",
        imageUrl: "/images/sma_liveaqua.jpg",
        location: "Calzada de la Presa 85, Centro, San Miguel de Allende, Guanajuato",
        rating: "4.9/5.0",
        features: ["Modern", "Spa", "Gourmet Dining", "Luxury"]
      },
      {
        id: "casa-hoyos-sma",
        name: "Casa Hoyos",
        name_es: "Casa Hoyos",
        description: "A design-forward boutique hotel in a restored colonial building, featuring bold contemporary interiors and a popular rooftop bar.",
        description_es: "Un hotel boutique de diseño en una casona colonial restaurada, con interiores contemporáneos y un popular bar en la azotea.",
        imageUrl: "/images/sma_casahoyos.jpg",
        location: "Mesones 14, Centro, San Miguel de Allende, Guanajuato",
        rating: "4.7/5.0",
        features: ["Boutique", "Design", "Rooftop Bar"]
      }
    ],
    diningExperiences: [
      {
        id: "tostevere-sma",
        name: "Tostévere",
        name_es: "Tostévere",
        description: "A creative, intimate restaurant celebrated for its bold flavors and modern Mexican fusion. Ambitious cuisine in a relaxed, artistic atmosphere.",
        description_es: "Un restaurante íntimo y creativo reconocido por sus sabores atrevidos y fusión moderna mexicana. Cocina ambiciosa en un ambiente artístico y relajado.",
        imageUrl: "/images/sma_tostevere.jpg",
        location: "Codo 4, Centro, San Miguel de Allende, Guanajuato",
        rating: "4.9/5.0",
        cuisine: ["Mexican Fusion", "Contemporary"],
        features: ["Intimate", "Artistic", "Vegan Options"]
      },
      {
        id: "salvajes-brasserie-sma",
        name: "Salvajes Brasserie",
        name_es: "Salvajes Brasserie",
        description: "A stylish brasserie offering modern European cuisine with local Mexican ingredients. Salvajes Brasserie is celebrated for its bold flavors, refined presentation, and cozy yet sophisticated setting.",
        description_es: "Una brasserie elegante que ofrece cocina europea moderna con ingredientes locales mexicanos. Salvajes Brasserie es reconocida por sus sabores audaces, presentación refinada y ambiente acogedor y sofisticado.",
        imageUrl: "/images/sma_salvajes.jpg",
        location: "Callejón del Pueblito 3, Centro, San Miguel de Allende, Guanajuato",
        rating: "4.9/5.0",
        cuisine: ["Modern European", "Mexican"],
        features: ["Creative Dishes", "Local Ingredients", "Cozy Atmosphere"]
      },
      {
        id: "tunki-rooftop-sma",
        name: "Tunki Rooftop by Handshake",
        name_es: "Tunki Rooftop by Handshake",
        description: "A vibrant rooftop restaurant and bar with Peruvian-inspired small plates and world-class cocktails by the acclaimed Handshake team. Enjoy creative cuisine, innovative drinks, and stunning views over San Miguel's historic center.",
        description_es: "Un animado restaurante y bar en la azotea con platillos pequeños de inspiración peruana y cocteles de clase mundial del aclamado equipo de Handshake. Disfruta cocina creativa, bebidas innovadoras y vistas impresionantes del centro histórico de San Miguel.",
        imageUrl: "/images/sma_tunki.jpg",
        location: "Hospicio 35, Centro, San Miguel de Allende, Guanajuato",
        rating: "4.8/5.0",
        cuisine: ["Peruvian-Inspired", "Small Plates", "Cocktails"],
        features: ["Rooftop", "Creative Cocktails", "Scenic Views", "Trendy Atmosphere"]
      },
      {
        id: "hacintto-sma",
        name: "Hacintto",
        name_es: "Hacintto",
        description: "Chef Regina Aguilar's Hacintto delivers fire-cooked, innovative cuisine in a sophisticated, contemporary space. Known for bold flavors and elegant plating.",
        description_es: "Hacintto de la Chef Regina Aguilar ofrece cocina innovadora al fuego en un espacio sofisticado y contemporáneo. Reconocido por sabores intensos y emplatados elegantes.",
        imageUrl: "/images/sma_hacintto.jpg",
        location: "Insurgentes 60, Centro, San Miguel de Allende, Guanajuato",
        rating: "4.8/5.0",
        cuisine: ["International", "Contemporary"],
        features: ["Chef Driven", "Sophisticated", "Fire Cooking"]
      },
      {
        id: "trasiego-sma",
        name: "Trasiego",
        name_es: "Trasiego",
        description: "Refined, contemporary Mexican cuisine in a stylish setting within Viñedo San Lucas. Perfect for wine lovers and gourmet experiences.",
        description_es: "Cocina mexicana contemporánea y refinada en un entorno elegante dentro de Viñedo San Lucas. Ideal para amantes del vino y experiencias gourmet.",
        imageUrl: "/images/sma_trasiegorestaurante.jpg",
        location: "Carr. a Dolores Hidalgo Km 3.5, Viñedo San Lucas, San Miguel de Allende, Guanajuato",
        rating: "4.9/5.0",
        cuisine: ["Mexican Contemporary", "Winery"],
        features: ["Vineyard", "Refined", "Wine Pairing"]
      },
      {
        id: "bovine-sma",
        name: "Bovine",
        name_es: "Bovine",
        description: "A modern brasserie and steakhouse known for upscale meat dishes, creative cocktails, and stylish art-deco interiors in the heart of San Miguel.",
        description_es: "Brasserie moderna y steakhouse famosa por sus cortes premium, cocteles creativos y elegantes interiores art-deco en el corazón de San Miguel.",
        imageUrl: "/images/sma_bovine.jpg",
        location: "Canal 16, Centro, San Miguel de Allende, Guanajuato",
        rating: "4.8/5.0",
        cuisine: ["Steakhouse", "Brasserie"],
        features: ["Art Deco", "Cocktails", "Upscale"]
      }
    ],
    bestTimeAndClimate: 'The best time to get married here is October to May. During these months, San Miguel de Allende enjoys perfect weather with warm days, cool nights, and minimal rainfall—ideal for outdoor celebrations and exploring the city. The dry season brings out the region\'s dramatic beauty, while summer offers lush landscapes and a festive spirit.',
    bestTimeAndClimate_es: 'La mejor época para casarse aquí es de octubre a mayo. Durante estos meses, San Miguel de Allende disfruta de un clima perfecto con días cálidos, noches frescas y lluvias mínimas—ideal para celebraciones al aire libre y explorar la ciudad. La temporada seca resalta la belleza dramática de la región, mientras que el verano ofrece paisajes exuberantes y un espíritu festivo.'
  },
  {
    slug: 'oaxaca',
    title: 'Oaxaca',
    title_es: 'Oaxaca',
    desc: "Cultural richness, colonial charm, authentic experiences.",
    desc_es: "Riqueza cultural, encanto colonial, experiencias auténticas.",
    image: '/images/oaxaca-1200.jpg',
    heroImage: '/images/oaxaca-1600.jpg',
    magicImage: '/images/oaxaca2-1200.jpg',
    footerSliverImage: '/images/oaxaca3-1600.jpg',
    sectionImage: '/images/beach_seating.jpg',
    overview: "Oaxaca is a UNESCO World Heritage site known for its rich cultural heritage, colonial architecture, and vibrant traditions.",
    overview_es: "Oaxaca es un sitio Patrimonio de la Humanidad por la UNESCO conocido por su rica herencia cultural, arquitectura colonial y tradiciones vibrantes.",
    weddingsDesc: "Weddings here blend colonial elegance with indigenous traditions, offering historic venues and authentic cultural experiences.",
    weddingsDesc_es: "Las bodas aquí combinan la elegancia colonial con tradiciones indígenas, ofreciendo lugares históricos y experiencias culturales auténticas.",
    bestTime: 'October to May',
    bestTime_es: 'Octubre a Mayo',
    nearestAirport: 'Oaxaca International Airport (OAX)',
    nearestAirport_es: 'Aeropuerto Internacional de Oaxaca (OAX)',
    airportInternational: 'Oaxaca International Airport (OAX)',
    airportInternational_es: 'Aeropuerto Internacional de Oaxaca (OAX)',
    airportDomestic: 'Oaxaca International Airport (OAX)',
    airportDomestic_es: 'Aeropuerto Internacional de Oaxaca (OAX)',
    airportPrivate: 'Oaxaca International Airport (OAX)',
    airportPrivate_es: 'Aeropuerto Internacional de Oaxaca (OAX)',
    featuredVenues: [
      { name: 'Quinta Real Oaxaca', image: '/images/quinta-real.jpg' },
      { name: 'Casa Oaxaca', image: '/images/casa-oaxaca.jpg' },
      { name: 'Hotel Escondido', image: '/images/hotel-escondido.jpg' },
    ],
    localTouch: "Experience traditional mezcal tastings, explore ancient ruins, and enjoy authentic Oaxacan cuisine.",
    localTouch_es: "Vive catas tradicionales de mezcal, explora ruinas antiguas y disfruta de la auténtica cocina oaxaqueña.",
    topActivities: [
      'Mezcal tasting',
      'Monte Albán ruins',
      'Cooking class',
      'Art gallery tour',
      'Textile workshop',
      'Market tour'
    ],
    topActivities_es: [
      'Cata de mezcal',
      'Ruinas de Monte Albán',
      'Clase de cocina',
      'Tour de galerías de arte',
      'Taller de textiles',
      'Tour del mercado'
    ],
    magicExperience: `Oaxaca is a living museum of Mexican culture and traditions. From the moment you arrive, you're immersed in a world where ancient customs blend seamlessly with colonial elegance. Picture colorful markets filled with handcrafted treasures, historic churches standing as testaments to centuries of faith, and vibrant festivals that bring the streets to life. Here, every celebration becomes a cultural journey, where traditional music, authentic cuisine, and local artisans create an unforgettable experience.`,
    magicExperience_es: `Oaxaca es un museo viviente de la cultura y tradiciones mexicanas. Desde el momento en que llegas, te sumerges en un mundo donde las costumbres antiguas se mezclan perfectamente con la elegancia colonial. Visualiza mercados coloridos llenos de tesoros artesanales, iglesias históricas que son testigos de siglos de fe y festivales vibrantes que dan vida a las calles. Aquí, cada celebración se convierte en un viaje cultural, donde la música tradicional, la cocina auténtica y los artesanos locales crean una experiencia inolvidable.`,
    vibe: `Oaxaca radiates an atmosphere of authentic charm and cultural richness. Days begin with café de olla in historic plazas, followed by market visits and leisurely strolls through colonial streets. As the sun sets, the city transforms into a celebration of tradition, with mezcal tastings, live music in courtyards, and candlelit dinners featuring the region's famous cuisine. Every moment here feels genuine, every experience meaningful, and every celebration infused with the magic of this cultural treasure.`,
    vibe_es: `Oaxaca irradia una atmósfera de encanto auténtico y riqueza cultural. Los días comienzan con café de olla en plazas históricas, seguidas de visitas al mercado y paseos por calles coloniales. Al caer el sol, la ciudad se transforma en una celebración de tradición, con catas de mezcal, música en vivo en patios y cenas iluminadas por velas con la famosa cocina de la región. Cada momento aquí se siente genuino, cada experiencia significativa y cada celebración impregnada con la magia de este tesoro cultural.`,
    climateSeasons: `From October to May, Oaxaca enjoys perfect weather with warm days, cool nights, and minimal rainfall—ideal for outdoor celebrations and exploring the city. The dry season brings out the region's dramatic beauty, while summer offers lush landscapes and a festive spirit.`,
    climateSeasons_es: `De octubre a mayo, Oaxaca disfruta de un clima perfecto con días cálidos, noches frescas y lluvias mínimas—ideal para celebraciones al aire libre y explorar la ciudad. La temporada seca resalta la belleza dramática de la región, mientras que el verano ofrece paisajes exuberantes y un espíritu festivo.`,
    accessibilityDetails: `Oaxaca is easily accessible through Oaxaca International Airport (OAX), which offers direct flights from Mexico City and other major cities. Upon arrival, the historic center is just a short transfer away, with many hotels offering private transportation services. The city's compact layout makes it easy to explore on foot, while taxis and private drivers are readily available for longer excursions.`,
    accessibilityDetails_es: `Oaxaca es fácilmente accesible a través del Aeropuerto Internacional de Oaxaca (OAX), que ofrece vuelos directos desde la Ciudad de México y otras ciudades principales. Al llegar, el centro histórico está a solo un corto traslado, con muchos hoteles ofreciendo servicios de transporte privado. El diseño compacto de la ciudad facilita la exploración a pie, mientras que taxis y conductores privados están fácilmente disponibles para excursiones más largas.`,
    experienceBlurb: 'From exploring ancient ruins to savoring authentic Oaxacan cuisine,',
    experienceBlurb_es: 'De explorar ruinas antiguas a saborear la auténtica cocina oaxaqueña,',
    weddingVenues: [
      "quinta-real-oaxaca",
      "casa-oaxaca",
      "hotel-escondido"
    ],
    bestWeddingVenues: [
      "quinta-real-oaxaca",
      "casa-oaxaca",
      "hotel-escondido"
    ],
    hotelsResortsStays: [
      {
        name: "Quinta Real Oaxaca",
        name_es: "Quinta Real Oaxaca",
        description: "A luxury hotel set in a 16th-century convent, offering stunning colonial architecture and exceptional service.",
        description_es: "Un hotel de lujo ubicado en un convento del siglo XVI, que ofrece impresionante arquitectura colonial y servicio excepcional.",
        imageUrl: "/images/quinta-real.jpg",
        rating: "5.0/5.0"
      },
      {
        name: "Casa Oaxaca",
        name_es: "Casa Oaxaca",
        description: "A boutique hotel known for its elegant design, exceptional restaurant, and authentic Oaxacan experience.",
        description_es: "Un hotel boutique conocido por su diseño elegante, restaurante excepcional y experiencia oaxaqueña auténtica.",
        imageUrl: "/images/casa-oaxaca.jpg",
        rating: "4.9/5.0"
      },
      {
        name: "Hotel Escondido",
        name_es: "Hotel Escondido",
        description: "A secluded beachfront retreat offering privacy, natural beauty, and authentic local experiences.",
        description_es: "Un retiro frente al mar que ofrece privacidad, belleza natural y experiencias locales auténticas.",
        imageUrl: "/images/hotel-escondido.jpg",
        rating: "5.0/5.0"
      }
    ],
    diningExperiences: [
      {
        name: "Casa Oaxaca El Restaurante",
        name_es: "Casa Oaxaca El Restaurante",
        description: "An elegant restaurant offering innovative Oaxacan cuisine in a beautiful colonial setting.",
        description_es: "Un elegante restaurante que ofrece cocina oaxaqueña innovadora en un hermoso entorno colonial.",
        imageUrl: "/images/casa-oaxaca-rest.jpg",
        rating: "4.9/5.0"
      },
      {
        name: "Criollo",
        name_es: "Criollo",
        description: "A sophisticated restaurant by Chef Enrique Olvera, celebrating traditional Oaxacan flavors with modern techniques.",
        description_es: "Un restaurante sofisticado del Chef Enrique Olvera, que celebra los sabores tradicionales oaxaqueños con técnicas modernas.",
        imageUrl: "/images/criollo.jpg",
        rating: "4.8/5.0"
      },
      {
        name: "Origen",
        name_es: "Origen",
        description: "A contemporary restaurant offering creative interpretations of traditional Oaxacan dishes.",
        description_es: "Un restaurante contemporáneo que ofrece interpretaciones creativas de platillos tradicionales oaxaqueños.",
        imageUrl: "/images/origen.jpg",
        rating: "4.8/5.0"
      }
    ],
    bestTimeAndClimate: 'The best time to get married here is October to May. During these months, Oaxaca enjoys perfect weather with warm days, cool nights, and minimal rainfall—ideal for outdoor celebrations and exploring the city. The dry season brings out the region\'s dramatic beauty, while summer offers lush landscapes and a festive spirit.',
    bestTimeAndClimate_es: 'La mejor época para casarse aquí es de octubre a mayo. Durante estos meses, Oaxaca disfruta de un clima perfecto con días cálidos, noches frescas y lluvias mínimas—ideal para celebraciones al aire libre y explorar la ciudad. La temporada seca resalta la belleza dramática de la región, mientras que el verano ofrece paisajes exuberantes y un espíritu festivo.'
  },
  
 
  
 
  {
    slug: 'guadalajara',
    title: 'Guadalajara',
    title_es: 'Guadalajara',
    desc: "Sophisticated charm, tequila heritage, elegant venues.",
    desc_es: "Encanto sofisticado, herencia del tequila, lugares elegantes.",
    image: '/images/guadalajara4-1200.jpg',
    heroImage: '/images/guadalajara1-1600.jpg',
    magicImage: '/images/guadalajara2-1200.jpg',
    footerSliverImage: '/images/guadalajara3-1600.jpg',
    sectionImage: '/images/beach_seating.jpg',
    overview: "Guadalajara is Mexico's second-largest city, known for its colonial architecture, tequila heritage, and sophisticated culture.",
    overview_es: "Guadalajara es la segunda ciudad más grande de México, conocida por su arquitectura colonial, herencia del tequila y cultura sofisticada.",
    weddingsDesc: "Weddings here combine urban sophistication with traditional charm, offering historic venues and modern luxury.",
    weddingsDesc_es: "Las bodas aquí combinan la sofisticación urbana con el encanto tradicional, ofreciendo lugares históricos y lujo moderno.",
    bestTime: 'October to May',
    bestTime_es: 'Octubre a Mayo',
    nearestAirport: 'Guadalajara International Airport (GDL)',
    nearestAirport_es: 'Aeropuerto Internacional de Guadalajara (GDL)',
    airportInternational: 'Guadalajara International Airport (GDL)',
    airportInternational_es: 'Aeropuerto Internacional de Guadalajara (GDL)',
    airportDomestic: 'Guadalajara International Airport (GDL)',
    airportDomestic_es: 'Aeropuerto Internacional de Guadalajara (GDL)',
    airportPrivate: 'Guadalajara International Airport (GDL)',
    airportPrivate_es: 'Aeropuerto Internacional de Guadalajara (GDL)',
    featuredVenues: [
      { name: 'Casa Fayette', image: '/images/casa-fayette.jpg' },
      { name: 'Hotel Demetria', image: '/images/demetria.jpg' },
      { name: 'Quinta Don José', image: '/images/quinta-don-jose.jpg' },
    ],
    localTouch: "Experience tequila tastings, explore historic plazas, and enjoy authentic Jalisco cuisine.",
    localTouch_es: "Vive catas de tequila, explora plazas históricas y disfruta de la auténtica cocina de Jalisco.",
    topActivities: [
      'Tequila tasting',
      'Historic center tour',
      'Art gallery visit',
      'Spa treatments',
      'Shopping',
      'Mariachi performance'
    ],
    topActivities_es: [
      'Cata de tequila',
      'Tour del centro histórico',
      'Visita a galerías de arte',
      'Tratamientos de spa',
      'Compras',
      'Presentación de mariachi'
    ],
    magicExperience: `Guadalajara is where tradition meets sophistication. From the moment you arrive, you're immersed in a world where colonial architecture stands alongside modern design, and tequila heritage blends with contemporary culture. Picture historic plazas filled with mariachi music, elegant haciendas transformed into luxury hotels, and rooftop terraces offering panoramic views of the city's iconic spires. Here, every celebration becomes a perfect blend of old-world charm and modern luxury.`,
    magicExperience_es: `Guadalajara es donde la tradición se encuentra con la sofisticación. Desde el momento en que llegas, te sumerges en un mundo donde la arquitectura colonial se alza junto al diseño moderno, y la herencia del tequila se mezcla con la cultura contemporánea. Visualiza plazas históricas llenas de música de mariachi, haciendas elegantes transformadas en hoteles de lujo y terrazas en la azotea que ofrecen vistas panorámicas de las icónicas agujas de la ciudad. Aquí, cada celebración se convierte en una mezcla perfecta de encanto de antaño y lujo moderno.`,
    vibe: `Guadalajara radiates an atmosphere of sophisticated charm and cultural richness. Days begin with café con leche in historic cafés, followed by gallery visits and leisurely strolls through colonial streets. As the sun sets, the city transforms into a celebration of tradition, with mariachi music filling the air, rooftop bars offering panoramic views, and candlelit dinners featuring the region's famous cuisine. Every moment here feels curated, every experience authentic, and every celebration infused with the magic of this cultural gem.`,
    vibe_es: `Guadalajara irradia una atmósfera de encanto sofisticado y riqueza cultural. Los días comienzan con café con leche en cafés históricos, seguidas de visitas a galerías y paseos por calles coloniales. Al caer el sol, la ciudad se transforma en una celebración de tradición, con música de mariachi llenando el aire, bares en la azotea que ofrecen vistas panorámicas y cenas iluminadas por velas con la famosa cocina de la región. Cada momento aquí se siente curado, cada experiencia auténtica y cada celebración impregnada con la magia de esta joya cultural.`,
    climateSeasons: `From October to May, Guadalajara enjoys perfect weather with warm days, cool nights, and minimal rainfall—ideal for outdoor celebrations and exploring the city. The dry season brings out the region's dramatic beauty, while summer offers lush landscapes and a festive spirit.`,
    climateSeasons_es: `De octubre a mayo, Guadalajara disfruta de un clima perfecto con días cálidos, noches frescas y lluvias mínimas—ideal para celebraciones al aire libre y explorar la ciudad. La temporada seca resalta la belleza dramática de la región, mientras que el verano ofrece paisajes exuberantes y un espíritu festivo.`,
    accessibilityDetails: `Guadalajara is easily accessible through Guadalajara International Airport (GDL), which offers numerous direct flights from major cities across Mexico and the US. Upon arrival, the historic center is just a short transfer away, with many hotels offering private transportation services. The city's well-maintained highway system makes it easy to explore different areas, from the historic center to the trendy neighborhoods.`,
    accessibilityDetails_es: `Guadalajara es fácilmente accesible a través del Aeropuerto Internacional de Guadalajara (GDL), que ofrece numerosos vuelos directos desde las principales ciudades de México y EE. UU. Al llegar, el centro histórico está a solo un corto traslado, con muchos hoteles ofreciendo servicios de transporte privado. El sistema de carreteras bien mantenido de la ciudad facilita la exploración de diferentes áreas, desde el centro histórico hasta los barrios de moda.`,
    experienceBlurb: 'From exploring historic plazas to enjoying tequila tastings in traditional haciendas,',
    experienceBlurb_es: 'De explorar plazas históricas a disfrutar de catas de tequila en haciendas tradicionales,',
    weddingVenues: [
      "casa-fayette",
      "hotel-demetria",
      "quinta-don-jose"
    ],
    bestWeddingVenues: [
      "casa-fayette",
      "hotel-demetria",
      "quinta-don-jose"
    ],
    hotelsResortsStays: [
      {
        name: "Casa Fayette",
        name_es: "Casa Fayette",
        description: "A boutique hotel in the trendy Lafayette neighborhood, featuring modern design and a vibrant atmosphere.",
        description_es: "Un hotel boutique en el barrio de moda Lafayette, con diseño moderno y una atmósfera vibrante.",
        imageUrl: "/images/casa-fayette.jpg",
        rating: "4.9/5.0"
      },
      {
        name: "Hotel Demetria",
        name_es: "Hotel Demetria",
        description: "A luxury hotel known for its elegant design, exceptional service, and stunning city views.",
        description_es: "Un hotel de lujo conocido por su diseño elegante, servicio excepcional e impresionantes vistas de la ciudad.",
        imageUrl: "/images/demetria.jpg",
        rating: "5.0/5.0"
      },
      {
        name: "Quinta Don José",
        name_es: "Quinta Don José",
        description: "A historic hacienda transformed into a luxury hotel, offering authentic charm and modern amenities.",
        description_es: "Una hacienda histórica transformada en un hotel de lujo, que ofrece encanto auténtico y amenidades modernas.",
        imageUrl: "/images/quinta-don-jose.jpg",
        rating: "5.0/5.0"
      }
    ],
    diningExperiences: [

    ],
    bestTimeAndClimate: 'The best time to get married here is October to May. During these months, Guadalajara disfruta de un clima perfecto con días cálidos, noches frescas y lluvias mínimas—ideal para celebraciones al aire libre y explorar la ciudad. La temporada seca resalta la belleza dramática de la región, mientras que el verano ofrece paisajes exuberantes y un espíritu festivo.'
  },
  {
    slug: 'puerto-vallarta',
    title: 'Puerto Vallarta',
    title_es: 'Puerto Vallarta',
    desc: "Pacific charm, vibrant culture, stunning sunsets.",
    desc_es: "Encanto del Pacífico, cultura vibrante, atardeceres impresionantes.",
    image: '/images/pv3.jpg',
    heroImage: '/images/pv1.jpg',
    magicImage: '/images/pv2.jpg',
    experienceImage: '/images/pv3.jpg',
    footerSliverImage: '/images/pv4.jpg',
    sectionImage: '/images/beach_seating.jpg',
    overview: "Puerto Vallarta is a picturesque coastal city known for its beautiful beaches, vibrant art scene, and lively boardwalk.",
    overview_es: "Puerto Vallarta es una pintoresca ciudad costera conocida por sus hermosas playas, vibrante escena artística y animado malecón.",
    weddingsDesc: "Weddings here blend Pacific beauty with Mexican warmth, offering everything from beachfront ceremonies to lush garden venues.",
    weddingsDesc_es: "Las bodas aquí combinan la belleza del Pacífico con la calidez mexicana, ofreciendo desde ceremonias en la playa hasta jardines exuberantes.",
    bestTime: 'November to May',
    bestTime_es: 'Noviembre a Mayo',
    nearestAirport: 'Licenciado Gustavo Díaz Ordaz International Airport (PVR)',
    nearestAirport_es: 'Aeropuerto Internacional Licenciado Gustavo Díaz Ordaz (PVR)',
    airportInternational: 'Licenciado Gustavo Díaz Ordaz International Airport (PVR)',
    airportInternational_es: 'Aeropuerto Internacional Licenciado Gustavo Díaz Ordaz (PVR)',
    airportDomestic: 'Licenciado Gustavo Díaz Ordaz International Airport (PVR)',
    airportDomestic_es: 'Aeropuerto Internacional Licenciado Gustavo Díaz Ordaz (PVR)',
    airportPrivate: 'Licenciado Gustavo Díaz Ordaz International Airport (PVR)',
    airportPrivate_es: 'Aeropuerto Internacional Licenciado Gustavo Díaz Ordaz (PVR)',
    featuredVenues: [
      { name: 'Four Seasons Resort Punta Mita', image: '/images/fourseasons_pv.jpg' }
    ],
    localTouch: "Enjoy sunset cruises, explore the Malecón, and savor fresh seafood by the beach.",
    localTouch_es: "Disfruta de cruceros al atardecer, explora el Malecón y saborea mariscos frescos junto a la playa.",
    topActivities: [
      'Sunset cruise',
      'Art walk',
      'Beach day',
      'Snorkeling',
      'Jungle adventure',
      'Malecón stroll'
    ],
    topActivities_es: [
      'Crucero al atardecer',
      'Caminata de arte',
      'Día de playa',
      'Snorkel',
      'Aventura en la selva',
      'Paseo por el Malecón'
    ],
    magicExperience: `Puerto Vallarta enchants with its blend of Pacific beauty and vibrant culture. Picture golden sunsets over the bay, cobblestone streets lined with art galleries, and celebrations that last long into the night.`,
    magicExperience_es: `Puerto Vallarta encanta con su mezcla de belleza del Pacífico y cultura vibrante. Imagina atardeceres dorados sobre la bahía, calles empedradas llenas de galerías de arte y celebraciones que duran hasta la noche.`,
    vibe: `Relaxed, artistic, and full of life—Puerto Vallarta is perfect for couples seeking both adventure and romance.`,
    vibe_es: `Relajado, artístico y lleno de vida—Puerto Vallarta es perfecto para parejas que buscan aventura y romance.`,
    climateSeasons: `From November to May, enjoy dry, sunny weather—ideal for beach weddings and outdoor celebrations. Summer brings lush greenery and occasional tropical showers.`,
    climateSeasons_es: `De noviembre a mayo, disfruta de clima seco y soleado—ideal para bodas en la playa y celebraciones al aire libre. El verano trae vegetación exuberante y lluvias tropicales ocasionales.`,
    accessibilityDetails: `Puerto Vallarta is easily accessible via its international airport, with direct flights from major cities. The city is compact and easy to explore by foot, taxi, or boat.`,
    accessibilityDetails_es: `Puerto Vallarta es fácilmente accesible a través de su aeropuerto internacional, con vuelos directos desde las principales ciudades. La ciudad es compacta y fácil de explorar a pie, en taxi o en barco.`,
    experienceBlurb: 'From sunset cruises to art walks along the Malecón,',
    experienceBlurb_es: 'De cruceros al atardecer a caminatas de arte por el Malecón,',
    weddingVenues: [
      'four-seasons-pv'
    ],
    bestWeddingVenues: [
      'four-seasons-pv'
    ],
    hotelsResortsStays: [
      {
        name: "Four Seasons Resort Punta Mita",
        name_es: "Four Seasons Resort Punta Mita",
        description: "A luxury beachfront resort with private beach club, world-class spa, and exceptional service.",
        description_es: "Un resort de lujo frente al mar con club de playa privado, spa de clase mundial y servicio excepcional.",
        imageUrl: "/images/fourseasons_pv.jpg",
        rating: "5.0/5.0"
      }
    ],
    diningExperiences: [
      {
        name: "Café des Artistes",
        name_es: "Café des Artistes",
        description: "A renowned restaurant blending French and Mexican cuisine in an elegant setting.",
        description_es: "Un restaurante reconocido que fusiona cocina francesa y mexicana en un entorno elegante.",
        imageUrl: "/images/cafedesartistes.jpg",
        rating: "4.9/5.0"
      },
      {
        name: "La Palapa",
        name_es: "La Palapa",
        description: "Beachfront dining with fresh seafood and tropical cocktails, perfect for sunset views.",
        description_es: "Restaurante frente al mar con mariscos frescos y cocteles tropicales, perfecto para ver el atardecer.",
        imageUrl: "/images/lapalapa.jpg",
        rating: "4.8/5.0"
      }
    ]
  }
];

export default destinationsData;